import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

import Element from '@/ui/Element'
import Button from '@/ui/Button/Button'
import Card from '@/ui/Card/Card'
import InputField from '@/ui/Input/InputField'

import LogoTitle from '../../media/el-logo.png'

import translate from '@/i18n/translate'
import { userLogin as userLoginAction } from '@/state/actions/auth'
import { routeReset } from '@/state/actions/routes'

const renderInput = ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) => (
  <InputField errorText={touched && error} {...inputProps} {...props} fullWidth />
)

const Login = props => {
  const login = ({ email, password }) => {
    const { userLogin } = props
    userLogin({ email, password })
  }
  const { handleSubmit, submitting, translate, theme } = props

  return (
    <Element classes="flex-center" theme={theme}>
      <Element classes="login-box" theme={theme}>
        <Card header={<img src={LogoTitle} alt="" />} theme={theme} classes="card-dark-header">
          <form onSubmit={handleSubmit(login)} className={theme['form']}>
            <div>
              <Field
                name="email"
                labelText="E-mail:"
                component={renderInput}
                style={{ width: '100%' }}
                placeholder="you@elovade.com"
                id="email"
              />
            </div>
            <div>
              <Field
                name="password"
                labelText="Password:"
                component={renderInput}
                style={{ width: '100%' }}
                placeholder={translate('i18n.auth.password')}
                id="password"
                type="password"
              />
            </div>
            <Button
              theme={theme}
              type="submit"
              classes={['success', 'block']}
              disabled={submitting}
            >
              Login
            </Button>
          </form>
        </Card>
        <div className={theme['text-center']}>
          <Button
            theme={theme}
            styles="forgot-button"
            classes="clean"
            onClick={() => props.dispatch(routeReset())}
          >
            Forgot Password ?
          </Button>
        </div>
      </Element>
    </Element>
  )
}

const enhance = compose(
  connect(null, { userLogin: userLoginAction }),
  translate,
  reduxForm({
    form: 'signIn',
    validate: (values, props) => {
      const errors = {}
      const { translate } = props
      if (!values.email) errors.email = translate('i18n.validation.required')
      if (!values.password) errors.password = translate('i18n.validation.required')
      return errors
    },
  }),
)

export default enhance(Login)



// WEBPACK FOOTER //
// ./view/Login/Login.js